import React from 'react'
import PropTypes from 'prop-types'
import {useProduct} from '@salesforce/commerce-sdk-react'
import WebDrawer from '../web-drawer'
import ProductSetGrid from '../../pages/product-detail/partials/product-set-grid'

const ProductSetQuickView = ({isOpen, onClose, productId, productName}) => {
    const {data: product, isLoading} = useProduct(
        {
            parameters: {
                id: productId,
                expand: ['set_products', 'images', 'prices', 'promotions'],
                allImages: true
            }
        },
        {enabled: Boolean(isOpen && productId), keepPreviousData: true}
    )

    const title = productName || product?.name || product?.productName
    const childProducts = product?.setProducts || []

    return (
        <WebDrawer isOpen={isOpen} onClose={onClose} title={title} size="85vh">
            <ProductSetGrid products={childProducts} isLoading={isLoading} showQV />
        </WebDrawer>
    )
}

ProductSetQuickView.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    productId: PropTypes.string,
    productName: PropTypes.string
}

export default ProductSetQuickView
